import { render, staticRenderFns } from "./WarehouseDetail.vue?vue&type=template&id=6836965e&scoped=true"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDetail.vue?vue&type=style&index=0&id=6836965e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6836965e",
  null
  
)

export default component.exports